import baseAPI from '@/api/base';
import { EditProjectEmployeeRole, GetProjectEmployeeRole, RegisterProjectEmployeeRole } from '@/dtos/project_employee_role.dto';
import {
  DELETE_PROJECT_EMPLOYEE_ROLE_URL,
  EDIT_PROJECT_EMPLOYEE_ROLE_URL,
  GET_PROJECT_EMPLOYEE_ROLE_URL,
  REGISTER_PROJECT_EMPLOYEE_ROLE_URL,
  TOGGLE_PROJECT_EMPLOYEE_ROLE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class ProjectEmployeeRole {
  static getProjectEmployeeRoles = async (getProjectEmployeeRole: GetProjectEmployeeRole): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PROJECT_EMPLOYEE_ROLE_URL, {
      params: getProjectEmployeeRole,
    });
    console.log('response', response);
    return response;
  };

  static registerProjectEmployeeRole = async (
    registerProjectEmployeeRole: RegisterProjectEmployeeRole
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_PROJECT_EMPLOYEE_ROLE_URL, {
      ...registerProjectEmployeeRole,
    });
    console.log('response', response);
    return response;
  };

  static editProjectEmployeeRole = async (editProjectEmployeeRole: EditProjectEmployeeRole): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_PROJECT_EMPLOYEE_ROLE_URL, {
      ...editProjectEmployeeRole,
    });
    return response;
  };

  static toggleProjectEmployeeRoleIsActive = async (
    editProjectEmployeeRole: EditProjectEmployeeRole
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_PROJECT_EMPLOYEE_ROLE_IS_ACTIVE_URL,
      {
        ...editProjectEmployeeRole,
      }
    );
    return response;
  };

  static deleteProjectEmployeeRole = async (projectEmployeeRoleId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_PROJECT_EMPLOYEE_ROLE_URL}/${projectEmployeeRoleId}`
    );
    return response;
  };
}

export default ProjectEmployeeRole;

